module.exports = __webpack_public_path__ + "static/media/User_icon.2a93819d.svg";